<template>
  <div>
    <!-- 业务页签账单详情弹出框 -->
    <el-dialog
      id="app"
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :title="requestSource === 'booking' ? $t('CargoMsg.Cargo_DomesticBill') : $t('Message.Bill')"
      fullscreen
      append-to-body
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      class="bill-dialog"
    >
      <div :style="'min-width: 1600px;' + (expandedGrid || !showBillForm ? 'height: 100%;display: flex;flex-direction: column;' : '')">
        <!--账单详情表单-->
        <div
          v-show="!expandedGrid"
          class="app-main-inner-row bill-dialog-form-wrapper"
        >
          <bill-form
            v-if="showBillForm"
            ref="billForm"
            :billing="billing"
            :billing-form-params="billingFormParams"
            :is-view="isView"
            :request-source="requestSource"
            :customer-detail="customerDetail"
            :create-bill-way="createBillWay"
            :accounts="accounts"
            @splitBill="splitBillChangeEvent"
            @calculateAmount="calculateAmount"
            @currencyChangeEvent="currencyChangeEvent"
            @accountIdChange="onAccountIdChange"
          />
        </div>
        <div class="app-main-inner-row" style="justify-content: center;font-size:30px;">
          <i :class="expandedGrid?'el-icon-caret-bottom':'el-icon-caret-top'" @click="expandedGrid=!expandedGrid" />
        </div>
        <div class="app-main-inner-row" style="justify-content: space-between">
          <div>
            <el-button
              v-if="!isView"
              type="primary"
              @click="addBillChargeEvent"
            >{{ this.$t('SeaExport.AddBillCharge') }}</el-button>
            <el-button
              v-if="!isView"
              type="primary"
              @click="removeBillChargeEvent"
            >{{ this.$t('SeaExport.RemoveBillCharge') }}</el-button>
            <el-checkbox v-show="!isView && chkShowLclVisible" v-model="chkShowLclSelected" style="margin-left: 10px;" @change="chkChangeHandler">{{ $t('SeaExport.ShowLcl') }}</el-checkbox>
            <!-- 指令操作按钮 -->
            <template v-for="(item, index) in instructionBtns">
              <el-button
                :key="index"
                :no="item.platformInstructionRuleCode"
                :type="getInstructionBtnType(item)"
                :disabled="!item.allowOperate || isView"
                :style="{marginLeft: index === 0 ? '5px' : ''}"
                @click="onInstructionClick(item)"
              >
                {{ getInstructionLabel(item) }}
              </el-button>
            </template>
          </div>
        </div>
        <div class="app-main-inner-row row-grid" :style="expandedGrid||!showBillForm?'flex-grow: 1;':'height:300px'">
          <cargo-ag-grid
            config-module="1301251"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            :style="{width:'100%',height:'auto'}"
            @gridReady="params=>{gridApi=params.api}"
          />
        </div>

        <!--加入费用-->
        <join-charge-dialog
          v-if="showJoinChargeDialog"
          :visible.sync="showJoinChargeDialog"
          :search-item-module="searchItemModule"
          :default-conditions="addChargeCondition"
          @addChargeCallBackEvent="addChargeCallBackEvent"
        />

        <!--冲突费用明细弹出框-->
        <conflict-charges-dialog
          v-if="showConflictChargeDialog"
          :visible.sync="showConflictChargeDialog"
          :charges="conflictCharges"
          view-source="billingDetail"
          @conflictChargeCallBackEvent="conflictChargeCallBackEvent"
        />
      </div>
      <div slot="footer">
        <el-button
          v-if="!isView && splitBillButton"
          :disabled="nowPage === 0"
          type="primary"
          @click="theLastPageHandler"
        >
          {{ $t('Invoice.invoice_theLastPage') }}
        </el-button>
        <el-button
          v-if="!isView && splitBillButton"
          :disabled="nowPage === splitCurrencyList.length - 1"
          type="primary"
          @click="theNextPageHandler"
        >
          {{ $t('Invoice.invoice_theNextPage') }}
        </el-button>
        <el-button v-permission="['button_InternalBillInfo_invoiceFromBilling']" :disabled="applyInvoiceDisabled" type="primary" @click="onApplyInvoiceClick(billing)">{{ $t('Billing.ApplyForInvoicing') }}</el-button>
        <el-button
          v-if="!isView"
          type="primary"
          @click="saveBilling"
        >{{ $t('SeaExport.Save') }}</el-button>
        <el-button @click="innerVisible=false">{{ $t('SeaExport.Cancel') }}</el-button>
        <span v-if="!isView && splitBillButton" style="padding-right: 5px;padding-left: 5px">{{ nowPage + 1 + '/' + splitCurrencyList.length }}</span>
      </div>
    </el-dialog>
    <!-- 多条业务 配置规则验证弹窗 -->
    <batch-checking-window
      v-if="batchCheckingWindow.visible"
      :visible.sync="batchCheckingWindow.visible"
      :lob="batchCheckingWindow.lob"
      :jobs="batchCheckingWindow.jobs"
      :check-node="batchCheckingWindow.checkNode"
      :call-back="batchCheckingWindow.callBack"
      :call-back2="batchCheckingWindow.callBack2"
    />
    <!-- 账单保存校验弹窗 -->
    <checking-save-job-window
      v-if="checkingSaveJobWindow.visible"
      :visible.sync="checkingSaveJobWindow.visible"
      :lob="checkingSaveJobWindow.lob"
      :row-data="checkingSaveJobWindow.rowData"
      :check-node="checkingSaveJobWindow.checkNode"
      :call-back="checkingSaveJobWindow.callBack"
    />
    <!-- 账单编辑费用弹窗 -->
    <bill-edit-charge-dialog
      v-if="billEditChargeDialog.visible"
      :visible.sync="billEditChargeDialog.visible"
      :title="billEditChargeDialog.title"
      :simple-jobs="billEditChargeDialog.simpleJobs"
      :job="job"
      :charge="billEditChargeDialog.charge"
      :currency-list="billEditChargeDialog.currencyList"
      :billing="billing"
      :split-bill="splitBillButton"
      @callback="saveBillEditChargeCallback"
    />
  </div>
</template>

<script>

import BillForm from './splitBillForm'
import { batchCheckPartyBillingNoExist, getBillingDetail } from '@/api/clearing/billingNative'
import * as BillingConstants from '@/class/cargo/model/parameters/BillingConstants'
import { Billing } from '@/class/model/act/Billing'
import StrUtils from '@/utils/StrUtils'
import joinChargeDialog from '@/components/Cargo/Act/joinChargeDialog'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { loadChargeOfBilling, checkPartyBillingNoExist } from '@/api/clearing/billingNative'
import SplitBillDetailHp from '@/components/Cargo/Act/splitBillDetailHp'
import { cache, cacheName } from '@/utils/cacheManager'
import { getBankAccountList } from '@/api/bankAccount'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import BatchCheckingWindow from '@/components/Cargo/Job/CheckingManager/BatchCheckingWindow.vue'
import * as CheckRuleConstants from '@/class/cargo/model/parameters/CheckRuleConstants'
import lodash from 'lodash'
import CheckingSaveJobWindow from '@/components/Cargo/Job/CheckingManager/CheckingSaveJobWindow.vue'
import { getLoading } from '@/utils/utilBaseElement'
import { checkChargeByBillingSaveNode } from '@/api/booking/job'
import BillEditChargeDialog from '@/components/Cargo/Act/billEditChargeDialog'
import { Charge } from '@/class/model/act/Charge'
import ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import BookingUtil from '@/class/cargo/model/utils/BookingUtil'
import { getChargeByUuid } from '@/api/clearing/charge'
import { AutoIncrementNum } from '@/utils/commonUtil'
import { Job } from '@/class/model/booking/Job'

export default {
  name: 'SplitBillDialog',
  components: {
    CheckingSaveJobWindow,
    BatchCheckingWindow,
    BillForm,
    BillEditChargeDialog,
    joinChargeDialog // 加入费用弹窗
  },
  props: {
    visible: { type: Boolean, required: true },
    reconciliationType: { type: String, default: 'charge' },
    billingUuid: { type: String, required: true },
    isView: { type: Boolean, required: true },
    newBilling: { type: Object, required: true },
    newCharges: { type: Array, required: true },
    currentBillingBranchId: { type: Number, required: false, default: 0 },
    departmentTeamUser: { type: Array, required: false, default: null },
    customerDetail: { type: Object, required: true },
    createBillWay: { type: Number, default: 0 }, // 创建账单方式【0：结算对象 1、结算代理】
    accounts: { type: Array, default: () => [] }, // 结算对象
    location: { type: String, required: false },
    showWhtTax: { type: Boolean, default: false },
    job: { type: Object, default: () => {} },
    slaveCharges: { type: Array, default: () => [] },
    instructionBtns: { type: Array, default: () => [] }
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      billDetailHp: new SplitBillDetailHp(this),
      innerVisible: false,
      showConflictChargeDialog: false, // 费用冲突显示弹出窗
      conflictCharges: [], // 账单保存时有冲突的费用集合
      showJoinChargeDialog: false,
      searchItemModule: '5042',
      addChargeCondition: {
        // 点击加入费用按钮时传递的参数
        exceptKeys: [],
        hasBillPayment: -1,
        hasBilling: -1,
        oversea: -1,
        currency: null,
        accountId: 0
      },
      isShowCounterPartyBillingNo: false, // 是否展示代理账单号
      expandedGrid: false,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        getRowStyle: function(params) {
          const data = params.data
          if (data) {
            if (data.hasOwnProperty('chargeVerifiedAmount')) {
              return (data.chargeConfirmState > 0 || data.chargeVerifiedAmount !== 0) ? { background: '#999999' } : { background: 'white' }
            } else {
              return data.chargeConfirmState > 0 ? { background: '#999999' } : { background: 'white' }
            }
          }
        }
      },
      gridParams: {},
      gridApi: null,
      rowData: [],
      billing: {
        uuid: '',
        version: 1,
        billingNo: '',
        accountId: 0,
        settlementAgentId: 0,
        buyerAddress: '',
        buyerTaxAccount: '',
        buyerTelephone: '',
        buyerBank: '',
        buyerBankAccount: '',
        ar: false,
        bankAccountId: 0,
        inputDate: '',
        billingType: '',
        currency: '',
        sourceCurrency1: '',
        sourceCurrency2: '',
        sourceCurrency3: '',
        sourceRate1: 0.0,
        sourceRate2: 0.0,
        sourceRate3: 0.0,
        amount1: 0.0,
        amount2: 0.0,
        amount3: 0.0,
        remark: '',
        invoiceDemand: '',
        state: 0,
        amount: 0.0,
        taxAmount: 0.0,
        title: '',
        bankAccount: '',
        taxFreeAmount: 0.0, // 不含税额虚拟字段，用于逻辑处理
        counterPartyBillingNo: '',
        chargeCurrency1: '',
        chargeCurrency2: '',
        chargeRate1: 0.0,
        chargeRate2: 0.0,
        billingGroupUuid: '',
        removedCharges: [], // 删除掉的费用
        updateCharges: [], // 更新的费用
        createCharges: [], // 新增的费用
        currentOfficeId: 0,
        settlement: '', // 结算对象虚拟字段，结算代理改变时，结算对象也要发生变更
        customerEmail: ''
      },
      requestSource: 'booking', // 用于账单保存 标识 业务tab 入口保存账单
      billingFormParams: {
        // 账单详情页 相关信息数据(除账单以为的数据)
        sourceRate1Enable: true, // 第一行汇率是否可编辑，默认不可编辑
        sourceRate2Enable: true, // 第二行汇率是否可编辑，默认不可编辑
        sourceRate3Enable: true // 第三行汇率是否可编辑，默认不可编辑}
      },
      showBillForm: false,
      searchConditions: {
        pageNum: 1,
        pageSize: 50,
        snapshotConditions: [] // 高级查询条件（点击查询时的快照状态）
      },
      batchCheckingWindow: {
        visible: false,
        jobs: [],
        checkNode: 0,
        callBack: null,
        callBack2: null,
        billDataList: []
      },
      checkingSaveJobWindow: {
        visible: false,
        rowData: [],
        lob: '',
        checkNode: 0,
        callBack: null
      },
      initialBilling: null, //
      splitBillData: {}, // 拆分的账单
      splitCurrencyList: [], // 拆分的币种
      nowPage: 0, // 当前页
      splitBillButton: false, //
      ourBankAccountArray: [], //
      isSaveBillRate: false, // 是否使用账单汇率进行计算
      chkShowLclSelected: false,
      chkShowLclVisible: false, // 是否显示小票费用 checkbox
      billEditChargeDialog: {
        visible: false,
        title: '',
        simpleJobs: [],
        charge: {},
        currencyList: []
      },
      autoIncrementNum: new AutoIncrementNum(),
      jobChargeCache: new Map() // 业务费用缓存
    }
  },
  computed: {
    total() {
      return this.rowData.length || 0
    },
    applyInvoiceDisabled() {
      return !this.billingUuid || this.rowData.findIndex(p => p.needInvoice) < 0
    },
    columnDefs() {
      const result = [
        // 费用列表
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('Billing.billingJob_businessNumber'),
          field: 'jobJobNo',
          width: 200
        },
        {
          headerName: this.$t('Billing.billingJob_mblNo'),
          field: 'jobMbl',
          width: 200
        },
        {
          headerName: this.$t('Billing.billingJob_vesselAndVoyageAndFlight'),
          field: 'jobVesselFlight',
          width: 200
        },
        {
          headerName: this.$t('Billing.billingJob_chargeItem'),
          field: 'chargeChargeItemId',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(
              TYPE_NAMES.basic_data_ChargeItem,
              'itemId',
              params.value,
              'zhName'
            )
          }
        },
        {
          headerName: this.$t('Billing.billingJob_paymentType'),
          field: 'chargeReceivable',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.chargeReceivableLabelFun(params.value)
          }
        },
        {
          headerName: this.$t('Billing.billingForm_collectAndPrepaidOrNot'),
          field: 'chargeAdvance',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          }
        },
        {
          headerName: this.$t('Billing.billingJob_currency'),
          field: 'chargeCurrency',
          width: 200
        },
        {
          headerName: this.$t('Billing.billingForm_unit'),
          field: 'chargeMeasure',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeUnit, 'code', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('Billing.billingJob_amount'),
          field: 'chargeQuantity',
          width: 200
        },
        {
          headerName: this.$t('Billing.billingJob_unitPrice'),
          field: 'chargeUnitRate',
          width: 200
        },
        {
          headerName: this.$t('Billing.billingJob_taxIncludedPrice'),
          field: 'chargeAmount',
          width: 200
        },
        {
          headerName: this.$t('Billing.billingJob_taxExcludedPrice'),
          field: 'chargeExcludingTaxAmount',
          width: 200
        },
        {
          headerName: this.$t('Billing.billingJob_taxRate'),
          field: 'chargeTaxRate',
          width: 200
        },
        {
          headerName: this.$t('Billing.billingJob_taxAmount'),
          field: 'chargeTaxAmount',
          width: 200
        },
        {
          headerName: this.$t('Billing.billingJob_separateNumber'),
          field: 'jobHbl',
          width: 200,
          hide: true
        },
        {
          headerName: this.$t('Billing.billingJob_remarks'),
          field: 'chargeRemarks',
          width: 200
        },
        {
          headerName: this.$t('FinanceManage.charge_invoiceHeader'),
          field: 'chargeInvoiceTitle',
          hide: true,
          width: 100
        }, {
          headerName: this.$t('FinanceManage.international_settlementAgent'),
          field: 'chargeSettlementAgentId',
          hide: true,
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('Billing.billingJob_itemNo'),
          field: 'jobPono',
          width: 200,
          hide: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Business_CustomerRefNo'),
          field: 'jobCustomerRefNo',
          width: 200
        }
      ]
      if (this.showWhtTax) {
        result.push({
          headerName: this.$t('FinanceManage.charge_whtTaxRate'),
          field: 'whtTaxRate',
          width: 100,
          valueFormatter: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value, 2)
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_whtTaxAmount'),
          field: 'whtTaxLocalAmount',
          width: 100,
          valueFormatter: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value, 2)
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_confirmOrNot'),
          field: 'chargeConfirmState',
          colId: 'chargeConfirmState',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          }
        }, {
          headerName: this.$t('FinanceManage.charge_notWhtAmount'),
          field: 'chargeNotWhtAmount',
          width: 200,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          }
        })
      }
      return result
    },
    isBySettlementAgent() { // 按结算代理新增
      return this.createBillWay === 1 && !this.billing.uuid
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
      if (!newVal) {
        this.rowData = []
        this.jobChargeCache.clear()
      }
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
    }
  },
  async beforeMount() {
    if (this.customerDetail && this.customerDetail.currencyRequirements === 3) {
      this.splitBillButton = true
    } else {
      this.splitBillButton = false
    }
    this.ourBankAccountArray = []
    await this.queryOurBankAccountList()
    await this.onShow()
  },
  methods: {
    getInvoiceUuidsFromCharges(charges) {
      const keys = new Set()
      for (const c of (charges || [])) {
        if (c && c.needInvoice && !StrUtils.isEmpty(c.invoiceUuid)) {
          keys.add(c.invoiceUuid)
        }
      }
      return Array.from(keys)
    },
    hasUnInvoicedNeedInvoiceCharge(charges) {
      for (const c of (charges || [])) {
        if (c && c.needInvoice && StrUtils.isEmpty(c.invoiceUuid)) return true
      }
      return false
    },
    onApplyInvoiceClick(billing) {
      const charges = this.rowData || []
      const invoiceUuids = this.getInvoiceUuidsFromCharges(charges)
      const hasUnInvoiced = this.hasUnInvoicedNeedInvoiceCharge(charges)
      if (!hasUnInvoiced && invoiceUuids.length > 0) {
        if (this.$listeners && this.$listeners.viewInvoice) {
          this.$emit('viewInvoice', invoiceUuids)
          return
        }
      }
      this.$emit('applyInvoice', billing)
    },
    async onShow(params) {
      params = params || {}
      const { isRepeatCall } = params
      await cache.load(cacheName.CONFIG)
      this.isSaveBillRate = Number(cache.config.get('isSaveBillRate')) === 1
      this.billingFormParams.eiTaxControlInterfaceName = String(cache.config.get('EITaxControlInterfaceName'))
      this.billingFormParams.billingNoteContainInvoiceReques = Number(cache.config.get('BillingNoteContainInvoiceReques'))
      this.billingFormParams.toExoSystemYGSH = String(cache.config.get('ToExoSystem')) === 'YGSH' // 阳光速航
      this.billingFormParams.newInvoiceTypesOfBilling = Number(cache.config.get('newInvoiceTypesOfBilling')) === 1
      if (!isRepeatCall) { // 初始化时执行，如果为重复调用，则忽略这段代码
        this.showLclCharge()
      }
      // 数据初始化
      this.rowData = []
      this.nowPage = 0
      this.billing = new Billing().fillDefaultValue().getData()
      // 编辑/查看 账单
      if (!StrUtils.isEmpty(this.billingUuid)) {
        this.queryBillingDetail()
      } else {
        // 新增账单
        this.billing = { ...this.newBilling }
        this.queryChargeOfBilling()
        this.showBillForm = true
      }
    },
    async saveBilling() {
      // 判断是否开启验证规则
      await cache.load(cacheName.CONFIG)
      const useCheckRule = Number(cache.config.get('useCheckRule')) === 1
      if (this.requestSource === 'booking') {
        if (useCheckRule) {
          const checkNodeFlag = await JobUtils.hasCheckRuleCondition(true, CheckRuleConstants.NODE_SAVE_BILLING.code, this.$store.getters.currentOfficeId)
          if (checkNodeFlag) {
            // 执行校验并处理校验结果
            const result = await this.performBillingValidation()
            if (result && result.needShowDialog) {
              this.showBillingValidationDialog(result.data)
            } else {
              await this.saveBillingDetail()
            }
          } else {
            await this.saveBillingDetail()
          }
        } else {
          await this.saveBillingDetail()
        }
        return
      }
      if (useCheckRule) {
        const checkNodeFlag = await JobUtils.hasCheckRuleCondition(true, CheckRuleConstants.NODE_SAVE_BILLING.code, this.$store.getters.currentOfficeId)
        if (checkNodeFlag) {
          const rows = lodash.cloneDeep(this.rowData)
          this.batchCheckingWindow.checkNode = CheckRuleConstants.NODE_SAVE_BILLING.code
          rows.forEach((item) => {
            item.lob = item.jobLob
            item.chargeUuid = item.uuid
            item.jobNo = item.jobJobNo
          })
          this.batchCheckingWindow.jobs = rows
          this.batchCheckingWindow.lob = this.rowData[0].jobLob
          this.batchCheckingWindow.callBack = this.saveBillingDetail
          this.batchCheckingWindow.callBack2 = null
          this.batchCheckingWindow.visible = true
        } else {
          await this.saveBillingDetail()
        }
      } else {
        await this.saveBillingDetail()
      }
    },
    // 执行账单校验
    async performBillingValidation() {
      // 调用实际的校验接口
      const requestData = {
        checkNode: CheckRuleConstants.NODE_SAVE_BILLING.code,
        chargeUuidList: this.rowData ? this.rowData.map(item => item.uuid) : [],
        branchId: this.$store.getters.currentOfficeId,
        billing: this.billing || {}
      }

      const loading = getLoading()
      const response = await checkChargeByBillingSaveNode(requestData).finally(
        () => loading.close()
      )
      if (response && response.data) {
        // 检查是否有校验失败的项
        const hasValidationErrors = this.checkValidationResult(response.data)

        return {
          needShowDialog: hasValidationErrors,
          data: response.data
        }
      }
    },

    // 检查校验结果是否有错误
    checkValidationResult(validationData) {
      if (!validationData) return false

      for (const key in validationData) {
        const rules = validationData[key]
        if (Array.isArray(rules)) {
          for (const rule of rules) {
            if (!rule.match && !rule.continueCheck) {
              return true // 有不匹配且不能继续的规则
            }
            if (!rule.match && rule.checkMode === 1) {
              return true // 有不匹配的错误级别规则
            }
          }
        }
      }
      return false
    },

    // 显示账单校验弹窗
    showBillingValidationDialog(validationData) {
      // 转换校验数据为CheckingSaveJobWindow组件需要的格式
      const convertedData = this.convertValidationDataForCheckingSaveJobWindow(validationData)

      this.checkingSaveJobWindow.checkNode = CheckRuleConstants.NODE_SAVE_BILLING.code
      this.checkingSaveJobWindow.rowData = convertedData
      this.checkingSaveJobWindow.callBack = this.saveBillingDetail
      this.checkingSaveJobWindow.visible = true
      this.checkingSaveJobWindow.lob = this.rowData[0].jobLob
    },

    // 转换校验数据格式以适配CheckingSaveJobWindow组件
    convertValidationDataForCheckingSaveJobWindow(validationData) {
      const result = []
      for (const key in validationData) {
        const rules = validationData[key]
        if (Array.isArray(rules)) {
          // 直接使用校验规则数据，CheckingSaveJobWindow会处理展示
          result.push(...rules)
        }
      }
      return result
    },
    // 查询账单详情
    queryBillingDetail() {
      getBillingDetail(this.billingUuid).then((res) => {
        this.billing = { ...res.data }
        this.billing.currentOfficeId = this.$store.getters.currentOfficeId // 当前分公司
        this.createBillWay = this.billing.createBillWay
        if (this.createBillWay === 1) {
          this.searchItemModule = '5044'
        }
        const billing = this.billing
        billing.removedCharges = []
        billing.createCharges = []
        billing.updateCharges = []
        billing.deletedChargeKeys = []
        this.isShowCounterPartyBillingNo = billing.billingType === BillingConstants.BILLING_TYPE_OVERSEA.code
        // 默认查询对账单关联的账单信息
        const uuid = billing.uuid
        if (uuid) {
          this.queryChargeOfBilling()
        }
        this.billDetailHp.querySettlement(billing.accountId)
        this.showBillForm = true
      })
    },
    // 查询账单关联的费用信息
    queryChargeOfBilling() {
      const requestBody = { branchId: 0, pageNum: this.searchConditions.pageNum, pageSize: this.searchConditions.pageSize, requestSource: 'BillingDetail_Charge', paging: false }
      if (this.billing.uuid) { // 针对于已经创建好的账单查询
        requestBody.billingKey = this.billing.uuid
      } else { // 针对于新增未保存的账单查询,根据费用UUID查询
        this.splitCurrencyList = []
        requestBody.chargeKeys = this.newCharges
      }
      requestBody.currentBillingBranchId = this.$store.getters.currentOfficeId
      loadChargeOfBilling(requestBody).then(async res => {
        // 获取全部费用
        if (res.data) {
          const list = [...res.data.list]
          if (this.splitBillButton) {
            // 根据费用分组 分别创建账单
            await this.setSplitCurrencyData(list)
            const currency = this.splitCurrencyList[0]
            // CARGO-45348 处理开票要求赋值
            const invoiceDemandPre = this.billing.invoiceDemand
            // 根据账单币种取计算好的账单数据
            this.billing = this.splitBillData[currency]
            if (!this.billing.uuid) {
              this.billing.invoiceDemand = this.billing.invoiceDemand ? this.billing.invoiceDemand : invoiceDemandPre
              for (const key in this.splitBillData) {
                if (key !== this.billing.currency) { this.$refs.billForm.invoiceDemandHandle(this.splitBillData[key]) }
              }
            }
            // 列表使用账单中记录费用
            this.rowData = this.billing.createCharges
          } else {
            await this.billDetailHp.setBankAccountData(this.billing)
            this.rowData = list
          }
        } else {
          this.rowData = []
        }
        await this.billDetailHp.refreshBilling()
        if (!this.billingUuid) {
          this.chkChangeHandler()
        }
      })
    },
    fetchDataByPage() {
      this.queryChargeOfBilling(this.billing.uuid)
    },
    // 加入费用
    addBillChargeEvent() {
      this.billDetailHp.addBillChargeEvent()
    },

    // 加入费用回调事件
    addChargeCallBackEvent(charges) {
      this.billDetailHp.addChargeCallBackEvent(charges)
    },
    // 移除费用
    async removeBillChargeEvent() {
      this.billDetailHp.removeBillChargeEvent()
    },
    // 费用冲突弹窗回调函数
    conflictChargeCallBackEvent(result) {
      this.billDetailHp.conflictChargeCallBackEvent(result)
    },
    // 保存账单
    async saveBillingDetail() {
      if (this.splitBillButton) {
        await this.doSaveSplitBillingDetail()
      } else {
        await this.doSaveBillingDetail()
      }
    },
    async doSaveSplitBillingDetail() {
      const splitBillData = { ...this.splitBillData }
      const counterPartyBillingNoList = []
      let tips = false
      // 校验对方账单号是否存在
      Object.keys(splitBillData).forEach(key => {
        const bill = splitBillData[key]
        if (bill.counterPartyBillingNo) {
          if (counterPartyBillingNoList.includes(bill.counterPartyBillingNo)) {
            // 拆分账单中存在对方账单号重复
            tips = true
          } else {
            counterPartyBillingNoList.push(bill.counterPartyBillingNo)
          }
        }
      })
      let resData = 0
      if (!tips && counterPartyBillingNoList.length > 0) {
        // 后端接口检查 拆分账单中是否存在对方账单号重复
        const res = await batchCheckPartyBillingNoExist(counterPartyBillingNoList, {
          branchId: this.billing.branchId,
          billKey: this.billing.uuid,
          billingType: this.billing.billingType
        })
        resData = res.data
      }
      // 拆分账单中存在重复 或后端检查出重复
      if (tips || resData > 0) {
        const flag = await this.$confirm(this.$t('Billing.OppositeBillNoAlreadyExists'), this.$t('Message.Prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          dangerouslyUseHTMLString: true,
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => true).catch(() => false)
        if (!flag) {
          return
        }
      }
      this.billDetailHp.saveSplitBilling()
      if (!this.billingUuid) {
        LocalStorageUtilsNew.setConfiguration('internal-showLclCharge', this.chkShowLclSelected)
      }
    },
    async doSaveBillingDetail() {
      if (this.billing.counterPartyBillingNo) {
        const res = await checkPartyBillingNoExist({
          branchId: this.billing.branchId,
          billKey: this.billing.uuid,
          billingType: this.billing.billingType,
          counterPartyBillingNo: this.billing.counterPartyBillingNo
        })
        if (res.data) {
          const flag = await this.$confirm(this.$t('Billing.OppositeBillNoAlreadyExists'), this.$t('Message.Prompt'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            dangerouslyUseHTMLString: true,
            closeOnClickModal: false,
            type: 'warning'
          }).then(() => true).catch(() => false)
          if (!flag) {
            return
          }
        }
      }
      // 校验开票抬头和结算代理
      const message = await this.billDetailHp.checkAgentAndTitle()
      let isSave = true
      if (!StrUtils.isEmpty(message)) {
        isSave = false
        await this.$confirm(message, this.$t('Message.Prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          distinguishCancelAndClose: true,
          type: 'warning'
        }).then(() => {
          isSave = true
        }).catch(() => {})
      }
      if (isSave) {
        this.billDetailHp.saveBillingDetail()
        if (!this.billingUuid) {
          LocalStorageUtilsNew.setConfiguration('internal-showLclCharge', this.chkShowLclSelected)
        }
      }
    },
    // 计算账单金额等属性
    async calculateAmount() {
      this.billDetailHp.calculateAmount()
    },
    // 账单币种修改事件
    async currencyChangeEvent(currency) {
      this.billDetailHp.currencyChangeEvent(currency)
    },
    // 触发按费用拆分账单
    async splitBillChangeEvent(splitBill) {
      this.splitBillButton = splitBill
      this.nowPage = 0
      this.onShow({ isRepeatCall: true })
    },
    // 显示拆分账单详细
    splitOnshow() {
      const splitCurrencyList = { ...this.splitCurrencyList }
      const splitBillData = this.splitBillData
      const currency = splitCurrencyList[this.nowPage]
      // 根据账单币种取计算好的账单数据
      this.billing = splitBillData[currency]
      // 列表使用账单中记录费用
      this.rowData = this.billing.createCharges
      this.billDetailHp.refreshBilling()
    },
    // 上一张
    theLastPageHandler() {
      if (this.nowPage > 0) {
        this.nowPage = this.nowPage - 1
      }
      this.splitOnshow()
    },
    // 下一张
    theNextPageHandler() {
      // 小于最大页数
      if (this.nowPage < this.splitCurrencyList.length - 1) {
        this.nowPage = this.nowPage + 1
      }
      this.splitOnshow()
    },
    async setSplitCurrencyData(list) {
      for (const c of list) {
        if (!this.splitCurrencyList.includes(c.chargeCurrency)) {
          this.splitCurrencyList.push(c.chargeCurrency)
        }
      }
      // 根据币种生成对应账单
      for (const billCurrency of this.splitCurrencyList) {
        // 根据币种生成对应账单
        let currencyBill = this.splitBillData[billCurrency]
        if (currencyBill === undefined || currencyBill === null) {
          currencyBill = await this.billDetailHp.initialBillingFunc()
          currencyBill.currency = billCurrency
          // 计算费用列表
          const chargeList = this.getChargesForCurrency(currencyBill.currency, list)
          // 计算账单金额
          await this.billDetailHp.calculationBilling(currencyBill, chargeList)
          await this.billDetailHp.setBankAccountData(currencyBill)
          // 拆分的费用 挂在账单上
          currencyBill.createCharges = chargeList
          this.splitBillData[billCurrency] = currencyBill
        }
      }
    },
    async queryOurBankAccountList() {
      await getBankAccountList(this.$store.getters.currentOfficeUuid).then((res) => {
        if (res.data && res.data.length > 0) {
          this.ourBankAccountArray = res.data
        }
      })
    },
    // 获取指定币种的费用
    getChargesForCurrency(currency, list) {
      const rList = []
      for (const c of list) {
        if (c.chargeCurrency === currency) {
          rList.push(c)
        }
      }
      return rList
    },
    onAccountIdChange() {
      this.chkChangeHandler()
    },
    /**
     * 是否显示小票费用
     */
    showLclCharge() {
      if (!this.billingUuid) {
        const showLclCharge = LocalStorageUtilsNew.getConfiguration('internal-showLclCharge')
        this.chkShowLclSelected = showLclCharge
      }
      this.chkShowLclVisible = this.job.masterFlag || false
    },
    // 显示小票费用
    async chkChangeHandler() {
      if (this.slaveCharges.length === 0) {
        return
      }
      if (this.splitBillButton) {
        for (const billCurrency of this.splitCurrencyList) {
          const currencyBill = this.splitBillData[billCurrency]
          if (!currencyBill) {
            continue
          }
          const chargeList = currencyBill.createCharges
          this.resetBillSlaveChareges(currencyBill, chargeList, true)
          await this.billDetailHp.calculationBilling(currencyBill, chargeList)
          this.billDetailHp.setBankAccountData(currencyBill)
        }
      } else {
        this.resetBillSlaveChareges(this.billing, this.rowData)
        this.billDetailHp.refreshInternalBillCharge()
      }
    },
    resetBillSlaveChareges(billing, rowData, byCurrency = false) {
      const field = !this.isBySettlementAgent ? 'chargeAccountId' : 'chargeSettlementAgentId'
      const cmpIdx = !this.isBySettlementAgent ? billing.accountId : billing.settlementAgentId
      const newRowData = rowData.filter(p => !p.addedLcl)
      rowData.splice(0, rowData.length, ...newRowData)
      const chargeKeySet = new Set()
      for (const item of rowData) {
        chargeKeySet.add(item.uuid)
      }
      for (const charge of this.slaveCharges) {
        if (byCurrency && charge.chargeCurrency !== billing.currency) {
          continue
        }
        if (charge[field] === cmpIdx && (this.chkShowLclSelected ? true : charge.jobUuid === this.job.uuid)) {
          if (!chargeKeySet.has(charge.uuid)) {
            rowData.push({ ...charge, entity: 'charge', dirty: true, chargeBillingAmount: 0, billingUuid: billing.uuid, billingNo: billing.billingNo, addedLcl: true })
            chargeKeySet.add(charge.uuid)
          }
        }
      }
    },
    getInstructionBtnType(item) {
      if (item.platformInstructionRuleCode === 'internalBillEdit' && item.instructionParamJson.editType === '删除费用') {
        return 'danger'
      }
      return 'primary'
    },
    getInstructionLabel(item) {
      if (item.platformInstructionRuleCode === 'internalBillEdit') {
        if (item.instructionParamJson.editType === '新增费用') {
          return this.$t('CargoMsg.Cargo_AddCharges')
        }
        if (item.instructionParamJson.editType === '编辑费用') {
          return this.$t('SeaExport.EditCharges')
        }
        if (item.instructionParamJson.editType === '删除费用') {
          return this.$t('CargoMsg.Cargo_DeleteFee')
        }
      }
      return this.$selectByLang(item.chineseName, item.englishName, item.japaneseName)
    },
    onInstructionClick(data) {
      if (data.platformInstructionRuleCode === 'internalBillEdit') {
        if (data.instructionParamJson.editType === '新增费用') {
          this.addBillCharge()
        }
        if (data.instructionParamJson.editType === '编辑费用') {
          this.editBillCharge()
        }
        if (data.instructionParamJson.editType === '删除费用') {
          this.removeBillCharge()
        }
      }
    },
    async addBillCharge() {
      const charge = new Charge().fillDefaultValue().getData()
      charge.currency = this.billing.currency
      charge.accountId = this.billing.accountId
      charge.settlementAgentId = this.billing.settlementAgentId
      charge.invoiceTitle = this.billing.title

      await BookingUtil.getNewCharge(charge, this.job, this.billing.ar)
      // 重新赋值，因为BookingUtil.getNewCharge会修改charge.accountId
      charge.accountId = this.billing.accountId

      await ChargeUtils.getChargeisOverseaNotControlledByConfig(charge)
      // 重新赋值，因为ChargeUtils.getChargeisOverseaNotControlledByConfig会修改charge.oversea
      charge.oversea = this.billing.billingType === BillingConstants.BILLING_TYPE_OVERSEA.code

      charge.refId = this.autoIncrementNum.getNextNum()
      charge.jobJobNo = this.job.jobNo
      this.showBillEditChargeDialog(charge)
    },
    async editBillCharge() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length !== 1) {
        this.$message.warning(this.$t('queryJob.PleaseAFeeToEdit'))
        return
      }
      if (!rows[0].uuid) {
        return
      }
      const row = rows[0]
      if (!row._charge && row.uuid) {
        row._charge = await getChargeByUuid(row.uuid).then(res => res.data)
        row.refId = row._charge.refId = this.autoIncrementNum.getNextNum()
      }
      const charge = row._charge
      if (!charge) {
        return
      }
      if (!await ChargeUtils.chargeIsModified({ ...charge, billingUuid: '' }, { uuid: charge.jobUuid })) {
        this.$message.warning(this.$t('queryJob.ThisFeeIsNotEditable'))
        return
      }
      charge.jobJobNo = rows[0].jobJobNo
      this.showBillEditChargeDialog(charge)
    },
    showBillEditChargeDialog(charge) {
      const jobMap = new Map()
      const currencySet = new Set()
      for (const item of this.rowData) {
        if (charge.uuid && charge.uuid === item.uuid) {
          continue
        }
        jobMap.set(item.jobUuid, { uuid: item.jobUuid, jobNo: item.jobJobNo })
        currencySet.add(item.chargeCurrency)
      }
      jobMap.set(charge.jobUuid, { uuid: charge.jobUuid, jobNo: charge.jobJobNo })
      this.billEditChargeDialog.title = charge.uuid ? this.$t('SeaExport.EditCharges') : this.$t('CargoMsg.Cargo_AddCharges')
      this.billEditChargeDialog.simpleJobs = [...jobMap.values()]
      this.billEditChargeDialog.charge = charge
      this.billEditChargeDialog.currencyList = this.splitBillButton ? [this.billing.currency] : [...currencySet]
      this.billEditChargeDialog.visible = true
    },
    saveBillEditChargeCallback(billCharge) {
      billCharge.refId = billCharge._charge.refId
      this.billDetailHp.editChargeCallBackEvent(billCharge)
    },
    removeBillCharge() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('queryJob.PleaseFeesYouWantDelete'))
        return
      }
      this.$confirm(this.$t('queryJob.AreWantToDeleteExpense'), this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('Message.Confirm'),
        cancelButtonText: this.$t('common.btn.cancel'),
        distinguishCancelAndClose: true,
        type: 'warning'
      }).then(async() => {
        await this.loadJobChargeCache(rows.map(p => p.jobUuid))
        const deleteRows = []
        for (const row of rows) {
          const charge = this.getCharge(row)
          if (!charge) {
            continue
          }
          if (charge.uuid && !await ChargeUtils.chargeIsDeleted({ ...charge, billingUuid: '' }, this.job.lob, this.jobChargeCache)) {
            continue
          }
          deleteRows.push(row)
        }
        if (deleteRows.length === 0) {
          return
        }
        await this.billDetailHp.deleteBillChargeEvent(deleteRows)
      })
    },
    async loadJobChargeCache(jobKeys) {
      for (const jobKey of jobKeys) {
        if (this.jobChargeCache.has(jobKey)) {
          continue
        }
        if (jobKey === this.job.uuid && this.job.charges) {
          this.jobChargeCache.set(jobKey, this.job.charges)
          continue
        }
        const jobModel = await new Job({ uuid: jobKey }).loadJobRelated({ charges: true })
        this.jobChargeCache.set(jobKey, jobModel.charges || [])
      }
    },
    getCharge(row) {
      if (row._charge) {
        return row._charge
      }
      const charges = this.jobChargeCache.get(row.jobUuid)
      return charges?.find(c => c.uuid === row.uuid) || null
    }
  }
}
</script>

<style lang="scss">
#app {
  &.bill-dialog {
    .el-dialog {
      display: flex;
      flex-direction: column;
      overflow: hidden;
    }
    .el-dialog__body{
      flex:1;
      overflow: scroll;
    }
    .el-scrollbar {
      &__view {
        display: flex;
        flex-direction: column;
      }
    }
    &-form-wrapper {
      .el-form-item__content {
        width: auto;
      }
    }
  }
}
</style>
